<script>
    export let width = '200px';
    export let height = '200px';

    let style = `width: ${width}; height: ${height}`;
</script>

<style>
    div {
        display: inline-block;
        margin: 0 auto;
    }
</style>

<div {style}>
    <svg width="100%" height="100%" viewBox="0 0 400 400" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
        <g transform="matrix(1,0,0,1,-2.79681,-2.60861)">
            <path d="M391.164,55.354C391.164,32.736 372.801,14.372 350.182,14.372L55.412,14.372C32.793,14.372 14.429,32.736 14.429,55.354L14.429,349.863C14.429,372.482 32.793,390.845 55.412,390.845L350.182,390.845C372.801,390.845 391.164,372.482 391.164,349.863L391.164,55.354Z" style="fill:rgb(101,201,202);"/>
        </g>
        <g transform="matrix(0.547868,0,0,0.702005,94.66,7.99729)">
            <rect x="184.545" y="29.746" width="15.455" height="109.835" style="fill:white;"/>
        </g>
        <g transform="matrix(0.547868,0,0,0.702005,94.66,179.118)">
            <rect x="184.545" y="29.746" width="15.455" height="109.835" style="fill:white;"/>
        </g>
        <g transform="matrix(1.09574,0,0,1.09574,5.32877,-52.2926)">
            <circle cx="177.662" cy="187.348" r="42.901" style="fill:white;fill-opacity:0;stroke:white;stroke-width:7.61px;"/>
        </g>
        <g transform="matrix(1.09574,0,0,1.09574,5.32877,118.828)">
            <circle cx="177.662" cy="187.348" r="42.901" style="fill:white;fill-opacity:0;stroke:white;stroke-width:7.61px;"/>
        </g>
    </svg>
</div>